import api from './api';
import { fetchPage } from './pagedParams';

const categoryService = {
  // Get all categories
  getAllCategories: async () => {
    const response = await api.get('/admin/categories');
    return response.data;
  },

  // Get active categories
  getActiveCategories: async () => {
    const response = await api.get('/admin/categories/active');
    return response.data;
  },

  // Get root categories (no parent)
  getRootCategories: async () => {
    const response = await api.get('/admin/categories/root');
    return response.data;
  },

  // Get subcategories
  getSubcategories: async (parentId) => {
    const response = await api.get(`/admin/categories/${parentId}/subcategories`);
    return response.data;
  },

  // Search categories
  searchCategories: async (query) => {
    const response = await api.get('/admin/categories/search', {
      params: { query }
    });
    return response.data;
  },

  // Get category by ID
  getCategoryById: async (id) => {
    const response = await api.get(`/admin/categories/${id}`);
    return response.data;
  },

  // Create category
  createCategory: async (categoryData) => {
    const response = await api.post('/admin/categories', categoryData);
    return response.data;
  },

  // Update category
  updateCategory: async (id, categoryData) => {
    const response = await api.put(`/admin/categories/${id}`, categoryData);
    return response.data;
  },

  // Toggle "sell on the website"
  toggleSellOnline: async (id) => {
    const response = await api.patch(`/admin/categories/${id}/toggle-sell-online`);
    return response.data;
  },

  // Toggle isActive
  toggleActive: async (id) => {
    const response = await api.patch(`/admin/categories/${id}/toggle-active`);
    return response.data;
  },

  // Delete category
  deleteCategory: async (id) => {
    const response = await api.delete(`/admin/categories/${id}`);
    return response.data;
  },

  // Server-side paged list (Spring Page) for the URL-driven DataTable.
  getCategoriesPage: (params) => fetchPage('/admin/categories/paged', params),

};

export default categoryService;